export interface Review {
  id: string;
  name: string;
  stars: number;
  text: string;
  category: "console" | "phone" | "laptop" | "computer" | "other";
  date: string;
  isPlaceholder: boolean;
}

export const reviews: Review[] = [
  {
    id: "r1",
    name: "Marcus T.",
    stars: 5,
    text: "Brought my PS5 in for HDMI port repair after another shop said it couldn't be fixed. Forum Technical Solutions had it working perfectly within the same day. Incredible work.",
    category: "console",
    date: "2024-09-15",
    isPlaceholder: true,
  },
  {
    id: "r2",
    name: "Priya S.",
    stars: 5,
    text: "My iPhone screen was completely shattered. They gave me a clear explanation of what needed to be done, and the repair was fast and clean. Screen looks brand new. Highly recommend.",
    category: "phone",
    date: "2024-10-02",
    isPlaceholder: true,
  },
  {
    id: "r3",
    name: "James W.",
    stars: 5,
    text: "My MacBook was overheating and shutting down randomly. The team diagnosed it quickly — needed a fan cleaning and thermal paste. Runs cool and quiet now. Great service.",
    category: "laptop",
    date: "2024-10-18",
    isPlaceholder: true,
  },
  {
    id: "r4",
    name: "Diana R.",
    stars: 5,
    text: "Xbox wouldn't turn on at all. Dropped it off in the morning, got a call by noon with a diagnosis. Fixed the same day. These guys know their stuff.",
    category: "console",
    date: "2024-11-05",
    isPlaceholder: true,
  },
  {
    id: "r5",
    name: "Kevin O.",
    stars: 5,
    text: "Laptop screen was cracked after a fall. The replacement was done professionally and the price was fair. Will definitely come back for any future repairs.",
    category: "laptop",
    date: "2024-11-20",
    isPlaceholder: true,
  },
  {
    id: "r6",
    name: "Tanya M.",
    stars: 5,
    text: "Called about my Nintendo Switch not charging. They walked me through what to check first, then I brought it in. Charging port replaced, works perfectly. Very honest shop.",
    category: "console",
    date: "2024-12-01",
    isPlaceholder: true,
  },
];